// extracted by mini-css-extract-plugin
module.exports = {"accordion":"BundleProductAccordion_accordion__cm5m_"};